// src/pages/HerstellerViewPage.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Heading, Text, VStack, Button } from "@chakra-ui/react";
import axios from "axios";

export default function HerstellerViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [hersteller, setHersteller] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller/${id}`)
      .then((res) => setHersteller(res.data))
      .catch((err) => console.error("Fehler beim Laden des Herstellers:", err));
  }, [id]);

  if (!hersteller) return <Text>Lade Herstellerdaten...</Text>;

  const typen = [
    hersteller.wechselrichter && "Wechselrichter",
    hersteller.energiespeicher && "Energiespeicher",
    hersteller.datenlogger && "Datenlogger",
    hersteller.modul && "Modul",
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Box maxW="2xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6}>
        Herstellerdetails
      </Heading>

      <VStack align="stretch" spacing={3}>
        <Detail label="Name" value={hersteller.name} />
        <Detail label="Typen" value={typen || "-"} />
      </VStack>

      <Button mt={6} colorScheme="blue" onClick={() => navigate(-1)}>
        Zurück
      </Button>
    </Box>
  );
}

function Detail({ label, value }) {
  return (
    <Text>
      <Text as="span" fontWeight="semibold">
        {label}:
      </Text>{" "}
      {value || "-"}
    </Text>
  );
}